export default __webpack_public_path__ + "static/media/nav_video.ec8a6ae2.svg";